/* Sharrow Videos scripts (converted from Squarespace). */
(function(){
  const root=document.getElementById('sharrowVideoHub');
  if(!root) return;
  const pills=root.querySelectorAll('.svh-pill');
  const cards=root.querySelectorAll('.svh-video-card');

  pills.forEach(pill=>{
    pill.addEventListener('click',()=>{
      const filter=pill.getAttribute('data-filter');
      pills.forEach(p=>p.classList.remove('active'));
      pill.classList.add('active');
      cards.forEach(card=>{
        const cats=card.getAttribute('data-category') || '';
        const show=filter === 'all' || cats.includes(filter);
        card.classList.toggle('svh-hidden', !show);
      });
    });
  });
})();
